module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "pt-sans",
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "ma-0": "",
      "pa-0": "",
      "fluid": ""
    }
  }, [_c('register-status'), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "offset-md1": "",
      "md10": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "mt-5": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md6": ""
    }
  }, [_c('featured')], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md6": ""
    }
  }, [_c('div', {
    staticClass: "pa-3"
  }, [_c('v-layout', {
    staticClass: "elevation-1",
    attrs: {
      "row": "",
      "wrap": "",
      "pa-4": ""
    }
  }, [_c('v-flex', {
    staticClass: "box-title",
    attrs: {
      "xs12": ""
    }
  }, [_c('strong', [_vm._v("Minha conta")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "147px"
    },
    attrs: {
      "src": _vm.company.logo,
      "alt": ""
    }
  })]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "mt-2": ""
    }
  }, [_c('strong', [_vm._v("Nome da empresa")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "mt-2": ""
    }
  }, [_vm._v("\n                " + _vm._s(_vm.company.tradingName) + "\n              ")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "mb-2": "",
      "mt-2": ""
    }
  }, [_c('v-divider')], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('strong', [_vm._v("Endereço")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_vm._v("\n                " + _vm._s(_vm.company.address) + " - " + _vm._s(_vm.company.addressNumber) + " / " + _vm._s(_vm.company.complement) + "\n              ")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "mb-2": "",
      "mt-2": ""
    }
  }, [_c('v-divider')], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('strong', [_vm._v("Seu contrato")])]), _vm._v(" "), _c('v-flex', {
    staticClass: "plano-btn",
    attrs: {
      "xs6": ""
    }
  }, [_c('div', {
    on: {
      "click": _vm.planos
    }
  }, [_vm._v("Plano básico")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "mt-2": ""
    }
  }, [_c('div', {
    staticClass: "link",
    on: {
      "click": _vm.cadastro
    }
  }, [_vm._v("\n                  Editar dados\n                ")])])], 1)], 1), _vm._v(" "), _c('overview')], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6bcb3686","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/painel/inicio/index.vue
// module id = 759
// module chunks = 3